/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { Injectable } from '@angular/core';
import { ApiService, OverviewAnytimeWitness } from '@midas/shared/common';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';
import { map } from 'rxjs';
import * as OverviewAnytimeWitnessActions from './overview-anytime-witness.actions';

@Injectable()
export class OverviewAnytimeWitnessEffects {
  readonly queryOverviewAnytimeWitness$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OverviewAnytimeWitnessActions.queryOverviewAnytimeWitness),
      fetch({
        run: ({limit, offset}) => {
          return this.api.get<{ count: number; items: OverviewAnytimeWitness[] }>('/overview/pending-anytime-witness').pipe(
            map((res) => {
              return OverviewAnytimeWitnessActions.queryOverviewAnytimeWitnessSuccess(res);
            }),
          );
        },
        onError: (action, error) => {
          return OverviewAnytimeWitnessActions.queryOverviewAnytimeWitnessError({ error });
        },
      }),
    );
  });

  constructor(private actions$: Actions, private api: ApiService) {}
}
